import { InteractionRequiredAuthError } from '@azure/msal-browser';
import { useMsal } from '@azure/msal-react';
import { useCallback } from 'react';

import { storageTokenRequest } from '~lib/auth/msal-config';

// Returns a getter that yields an ABS-scoped access token. Silent acquisition
// against the active account; falls back to interactive redirect if the cache
// has expired or consent was revoked.
export function useStorageToken(): () => Promise<string> {
  const { instance, accounts } = useMsal();

  return useCallback(async () => {
    const account = accounts[0] ?? instance.getActiveAccount();
    if (!account) {
      throw new Error('No signed-in account; cannot acquire storage token.');
    }

    try {
      const result = await instance.acquireTokenSilent({
        ...storageTokenRequest,
        account,
      });
      return result.accessToken;
    } catch (error) {
      if (error instanceof InteractionRequiredAuthError) {
        await instance.acquireTokenRedirect(storageTokenRequest);
        // Redirect navigates away; this throw is just to satisfy the type
        // checker since execution doesn't actually continue here.
        throw error;
      }
      throw error;
    }
  }, [instance, accounts]);
}
